export const formatBigNumbers = (value: number | string): string => {
    if (typeof value === "string") {
        return value;
    }

    if (value >= 1000000) {
        return `${value.toString().slice(0, 1)} ${value.toString().slice(1, 4)} ${value.toString().slice(4)}`;
    }
    if (value >= 100000) {
        return `${value.toString().slice(0, 3)} ${value.toString().slice(3)}`;
    }
    if (value >= 10000) {
        return `${value.toString().slice(0, 2)} ${value.toString().slice(2)}`;
    }
    if (value >= 1000) {
        return `${value.toString().slice(0, 1)} ${value.toString().slice(1)}`;
    }
    return value.toString();
};
export const formatBigNumbers = (value: number | string): string => {
    if (typeof value === "string") {
        return value;
    }

    if (value >= 1000000) {
        return `${value.toString().slice(0, 1)} ${value.toString().slice(1, 4)} ${value.toString().slice(4)}`;
    }
    if (value >= 100000) {
        return `${value.toString().slice(0, 3)} ${value.toString().slice(3)}`;
    }
    if (value >= 10000) {
        return `${value.toString().slice(0, 2)} ${value.toString().slice(2)}`;
    }
    if (value >= 1000) {
        return `${value.toString().slice(0, 1)} ${value.toString().slice(1)}`;
    }
    return value.toString();
};
